export enum ShouldResetHomeForm {
  YES,
  NO,
}
